import i18n from "@/i18n";
import { createSlice } from "@reduxjs/toolkit";

// Normalize language to supported languages (en, es)
const normalizeLanguage = (lng: string | null): string => {
  if (!lng) return "en";
  const baseLang = lng.split("-")[0].toLowerCase();
  return baseLang === "es" ? "es" : "en"; // Default to English for any non-Spanish language
};

const initialState = {
  language: normalizeLanguage(localStorage.getItem("language")), // Initialize from localStorage with normalization
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      i18n.changeLanguage(action.payload); // Sync with i18n
      localStorage.setItem("language", action.payload); // Store in localStorage
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;